import { render, staticRenderFns } from "./AppWorkAnalyzerReport.vue?vue&type=template&id=06b4efaa&scoped=true&"
import script from "./AppWorkAnalyzerReport.vue?vue&type=script&lang=js&"
export * from "./AppWorkAnalyzerReport.vue?vue&type=script&lang=js&"
import style0 from "./AppWorkAnalyzerReport.vue?vue&type=style&index=0&id=06b4efaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4efaa",
  null
  
)

export default component.exports